// extracted by mini-css-extract-plugin
export default {"container":"Container_container__1S08l","min-height":"Container_min-height__5LBfy","start":"Container_start__ev1lb","column":"Container_column__0BooH"};